<div class="promo-codes-add">
  <h2 *ngIf="!hideHeader">Add a promo code</h2>

  <section fxLayout="column" fxLayoutGap="24px">
    <div fxLayout="column">
      <label class="strong">Codes</label>

      <div class="max-width-680">
        <div fxLayout fxLayoutGap="8px">
          <mat-form-field class="nopadding" fxFlex>
            <input
              #codeInput
              matInput
              minlength="2"
              maxlength="64"
              placeholder="eg. 'SAVE10', 'BOOKDIRECT'"
              (keyup)="validateCodeInput(codeInput)"
              (keyup.enter)="addCode(codeInput.value)"
              (blur)="addCode(codeInput.value)" />
          </mat-form-field>
        </div>
        <span class="card__collapsed-helper-text">2-64 characters, letters and numbers only</span>
      </div>

      <div *ngIf="promoCode.codes?.length > 0" class="codes-container" fxLayout="row wrap" fxLayoutGap="12px">
        <div
          *ngFor="let code of promoCode.codes"
          class="properties__tags"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="4px">
          <span class="ellipsis">{{ code }}</span>
          <span class="properties__tags-close" (click)="removeCode(code)">x</span>
        </div>
      </div>
    </div>

    <div fxLayout="column">
      <label class="strong">Discount amount</label>

      <div fxLayout fxLayoutGap="8px">
        <mat-form-field class="nopadding" fxFlex="320px">
          <input
            matInput
            type="number"
            placeholder="0"
            step="5"
            [(ngModel)]="promoCode.discount_amount"
            (change)="checkFixedBounds()"
            onwheel="this.blur()" />
          <span matSuffix [matMenuTriggerFor]="currencyMenu">
            <ng-container *ngIf="promoCode.discount_type === PromoCodeType.Percentage">%</ng-container>
            <ng-container *ngIf="promoCode.discount_type === PromoCodeType.Fixed">
              {{ promoCode.currency || 'Currency' }}
            </ng-container>

            <img fxFlex class="clickable" style="width: 12px; margin-left: 4px" src="/assets/images/down-arrow.svg" />
          </span>
          <mat-menu #currencyMenu="matMenu" class="filters__cdk-menu">
            <div mat-menu-item (click)="setPercentageType()">%</div>

            <div *ngFor="let currency of currencies" mat-menu-item (click)="updateCurrency(currency)">
              {{ currency.key }}
            </div>
          </mat-menu>
        </mat-form-field>
      </div>
    </div>

    <!-- <div *ngIf="promoCode.discount_type === PromoCodeType.Percentage" fxLayout="column">
      <label class="strong">Maximum discount value</label>

      <div fxLayout fxLayoutGap="8px">
        <mat-form-field class="nopadding" fxFlex="320px">
          <input matInput type="number" placeholder="0" step="5" [(ngModel)]="promoCode.max_discount"
            (change)="checkMaxDiscountBounds()" onwheel="this.blur()" />
        </mat-form-field>
      </div>
      <span class="card__collapsed-helper-text">Set a maximum value for this discount (optional)</span>
    </div> -->
  </section>
</div>
